export const zdfColorsDark: Record<string, string> = {

    // Text
    colorTextPrimary: "#FFFFFF",
    colorTextSecondaryOnLightColorBg: "#2D3746",
    colorTextSecondary: "#BBC0C5",
    colorTextDisabled: "#969BA2",
    colorTextHint: "#ABAFB5",
    colorTextHighlight: "#FA7D19",
    colorTextWarning: "#FFFFFF",
    colorTextSuccess: "#BEE2AD",

    //on-primary-button
    //on-accent-button

    colorTextOnBlackBackground: "#2D3746",
    colorTextOnDarkBackground: "#FFFFFF",
    colorTextOnLightColorTag: "#2D3746",
    colorTextPrimaryOnLightColorBg: "#FFFFFF",

    // Button
    colorButtonPrimary: "#FA7D19",
    colorButtonAccent: "#FA7D19",
    colorButtonSecondary: "#1D2E3E",
    colorButtonDisabled: "#4D535C",

    // Surface
    colorSurfacePrimary: "#0B1C2C",
    colorSurfaceSecondary: "#1D2E3E",
    colorSurfaceDiscovery: "#1C3A56",
    colorSurfaceDiscoveryShade: "#1D2F3F",
    colorSurfaceInfo: "#1D2E3E",

    //Border
    colorBorderPrimary: "#D9D9D9",
    colorGreyHoverBorder: "#FFFFFF",
    colorBorderSelected: "#FFFFFF",
    colorBorderFacepile: "#0B1C2C",

    //Hover
    colorBlackHover: "#FFFFFF",
    colorGreyHover: "#2D3746",
    colorGreyFormHover: "#2D3746",

    //Press
    colorGreyFormPress: "#444F61",
    colorSecondaryPress: "#444F61",
    colorIconButtonPress: "#444F61",

    //Teaser
    colorTeaserBackground: "#1D2E3E",
    colorMintGreenBackground: "#1C3A56",
    colorTealBackground: "#0B1C2C",

    //Tag
    colorTagHighlight: "#FAEFE6",

    //DataViz
    colorDataVizStrong: "#FAA35C",
    colorDataVizLight: "#FFCFA8",
    colorDataVizRegular: "#43596E",

    //Bar
    colorBarBackground: "#FA7D19",

    //Secondary
    colorSecondaryJasper: "#1D2E3E",
}